import { FC } from 'react';
import { Navigate } from 'react-router-dom';

const SignoutCallback: FC = () => {
  const url = new URL(window.location.href);

  if (url.searchParams.has('targetState')) {
    return <Navigate to={`/${url.searchParams.get('targetState')}`} />;
  }

  return <Navigate to="/?logout=true" />;
};

export default SignoutCallback;
